import { CardUser } from "../../element/Card";
import OpenLinkButton from "../../element/Download";
import {useState, useEffect} from 'react'
import { db } from '../../firebase/FirebaseConfig';
import {collection, getDocs, query, where} from 'firebase/firestore';
import { auth } from '../../firebase/FirebaseConfig';
import { Tribe } from '../../List/TribeList'
import { Know } from "../../List/Knowledgedlist";
import Loader from '../../element/Loader'
import {View, ScrollView, useWindowDimensions} from 'react-native'
import { Title } from "../../element/Text";



const Download1 = ({navigation})=>{
    const [characters, setChatacters]=useState([])
    const window= useWindowDimensions()
    const [flip, setFlip]=useState(false)
    const [flip1, setFlip1]=useState(false)
    const [flip2, setFlip2]=useState(false)
    
    const user= auth.currentUser

useEffect(()=>{
    const unsubscribe = navigation.addListener('focus', () => {
        kimera()
      });
},[navigation])
  
async function kimera(){
    
    let png=[]
    let information=query(collection(db,"personaggi"),where("User","==",user.uid), where("Death","==",false));
    let querySnapshot= await getDocs(information);
          querySnapshot.forEach((docs)=>{png.push(docs.data());});
            setChatacters(png)
       
          if(png[0]!=undefined){ setFlip1(true)}
          else{setFlip1(false)}
            if (png[0].Complete==true){setFlip2(true)}
          setFlip(true)  
          
          setTimeout(5000)
          
}

function List(){
    
    

    return (
        <View style={{alignItems:'center', width:window.width, height:window.height}}>
        <CardUser icon={false} logo={true} width={'95%'} height={'80%'} maxWidth={450}>
        <ScrollView style={{width:'100%',  height:'90%'}} contentContainerStyle={{alignItems:'center', justifyContent:'center',marginVertical:35}} showsVerticalScrollIndicator={true} >  
            <OpenLinkButton url={'https://files.avernum.org/regolamento_avernum-v1.2.pdf'} text={'Regolamento'}/>
            <OpenLinkButton url={'https://files.avernum.org/manuale_magia_incantesimi.pdf'} text={'Manuale Magia'}/>
        {flip1? <OpenLinkButton url={Tribe[Tribe.findIndex((obj)=>obj.name===characters[0].Tribe)].site} text={characters[0].Tribe}/>:<></>}
        {flip2? <View style={{marginTop:35, width:'90%', height:50}}>{characters[0].Abilita.includes("CONOSCENZE METALLI")? <OpenLinkButton url={Know[0].site} text={"Conoscenza Metalli"}/>:<></>}</View>:<></>}
        {flip2? <View style={{marginTop:35, width:'90%', height:50}}> {characters[0].Abilita.includes("CONOSCENZE ALCHIMIA")? <OpenLinkButton url={Know[1].site} text={"Conoscenza Alchimia"}/>:<></>}</View>:<></>}
        {flip2? <View style={{marginTop:35 , width:'90%', height:50}}> {characters[0].Abilita.includes("CONOSCENZE ERBORISTERIA")? <OpenLinkButton url={Know[2].site} text={"Conoscenze Erboristeria"}/>:<></>}</View>:<></>}
        {flip2? <View style={{marginTop:35, width:'90%', height:50}}> {characters[0].Abilita.includes("CONOSCENZE GEOGRAFIA")? <OpenLinkButton url={Know[3].site} text={"Conoscenze Geografia"}/>:<></>}</View>:<></>}
        {flip2? <View style={{marginTop:35, width:'90%', height:50}}> {characters[0].Abilita.includes("CONOSCENZE MEDICINA")? <OpenLinkButton url={Know[5].site} text={"Conoscenze Medicina"}/>:<></>}</View>:<></>}
        {flip2? <View style={{marginTop:35, width:'90%', height:50}}> {characters[0].Abilita.includes("CONOSCENZE MITI E LEGGENDE")? <OpenLinkButton url={Know[4].site} text={"Conoscenze Miti e Legende"}/>:<></>}</View>:<></>}
          </ScrollView>
            </CardUser>
            </View>
    )}

return(
<View style={{width:'100%', height:'100%'}}>{flip? <List/>:<View style={{width:'100%', height:'100%', alignItems:'center', justifyContent:'center'}}><Loader/></View>}</View>
)

}
export default Download1